module.exports = __webpack_public_path__ + "static/media/ocupacion_suelo.ae7c9787.png";